const statisticsRouter = [
  {
    path: 'customer',
    name: 'customer',
    component: () => import('@/views/wxapp/designer-manager/statistics/index'),
    meta: {
      title: '数据分析'
    }
  }
]
export default statisticsRouter
